export function defaultUserAgent(packageName, packageVersion) {
  var originUserAgent = typeof navigator !== "undefined" && typeof navigator.userAgent === "string" ? navigator.userAgent : "";
  return "aws-sdk-js-v3-" + packageName + "/" + packageVersion + " " + originUserAgent;
}